import { waitUntilGliderIsLoaded } from "./_waitUntilGliderIsLoaded";

/**
 * Create a slider from a toujou item list content element
 *
 * @param {HTMLElement} list
 * @param {String} sliderIdentifierClass
 * @returns {Promise<void>}
 */
export async function createSliderFromItemList(list, sliderIdentifierClass) {
    const cards = list.querySelectorAll('.toujou-card');

    const gliderAvailable = await waitUntilGliderIsLoaded();

    // Create slider elements
    const sliderWrapper = document.createElement("div");
    sliderWrapper.classList.add("slider-wrapper");

    const slider = document.createElement('toujou-slider');
    slider.classList.add(sliderIdentifierClass, 'slider');

    const sliderFrame = document.createElement("div");
    sliderFrame.classList.add('slider__frame');

    // Add cards to the new slider markup
    cards.forEach((card) => {
        sliderFrame.appendChild(card);
    });

    slider.appendChild(sliderFrame);

    // Create controls
    const controlsWrapper = document.createElement('div');
    controlsWrapper.classList.add('controls-wrapper');

    const sliderBulletsContainer = document.createElement('div');
    sliderBulletsContainer.classList = 'slider__bullets';

    const arrowLeftSVG = `<svg height="24" width="24" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet"><use xlink:href="#arrow_left"></use></svg>`;
    const arrowRightSVG = `<svg height="24" width="24" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet"><use xlink:href="#arrow_right"></use></svg>`;

    const sliderArrowPrev = document.createElement('span');
    sliderArrowPrev.classList = 'slider__control slider__control--prev';
    sliderArrowPrev.insertAdjacentHTML('beforeend', arrowLeftSVG);

    const sliderArrowNext = document.createElement('span');
    sliderArrowNext.classList = 'slider__control slider__control--next';
    sliderArrowNext.insertAdjacentHTML('beforeend', arrowRightSVG);

    // Add controls to controls wrapper
    controlsWrapper.appendChild(sliderArrowPrev);
    controlsWrapper.appendChild(sliderBulletsContainer);
    controlsWrapper.appendChild(sliderArrowNext);

    // Add controls wrapper with controls to the slider element
    slider.appendChild(controlsWrapper);

    // Add slider to the page after the original item-list content element
    list.after(slider);

    // Remove the original item-list content element from the page (should be empty by now)
    list.remove();

    // Initialize the slider
    try {
        const sliderOptions = {
            slidesToShow: 1,
            slidesToScroll: 1,
            rewind: true,
            draggable: true,
            scrollLock: true,
            responsive: [
                {
                    breakpoint: 540,
                    settings: { slidesToShow: 2 },
                },
                {
                    breakpoint: 960,
                    settings: { slidesToShow: 3 },
                },
                {
                    breakpoint: 1280,
                    settings: { slidesToShow: 4 },
                },
            ],
            arrows: {
                prev: sliderArrowPrev,
                next: sliderArrowNext,
            },
            dots: sliderBulletsContainer,
        };

        slider._glider = new Glider(sliderFrame, sliderOptions);
        slider._glider.refresh(true);
    } catch (error) {
        console.log('Could not initialize list slider', error)
    }
}
